export const FORMATS = ['bold', 'link', 'underline', 'indent', 'list', 'align', 'direction'];

export const LINE_BREAK_ONLY_FORMATS: string[] = [];

export const HTML_CONTENT_PATTERN =
  /<\/?(?:p|br|div|span|ol|ul|li|strong|em|b|i|u|a|s|sub|sup|pre|code|blockquote|h[1-6])[\s>/]/i;

export const LIST_PATTERN = /<(ol|ul)[^>]*>/i;

export const LEVEL_PATTERN = /([CTLS])(\d+)\/([CTLS])(\d+)/;

export const OVERALL_PATTERN = /Overall\s+\w+:/;

export const ESCAPED_HTML_PATTERN = /<p>[\s\S]*&lt;[\s\S]*&gt;[\s\S]*<\/p>/;
